import { yupResolver } from '@hookform/resolvers/yup';
import { IScreenFormMeta } from '@Modules/admin/integrationSettings/containers/forms/atm/screenGAB/screenMeta';
import { CustomButton, CustomInputCheckBox, CustomTextArea, CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: IScreenFormMeta
} & TFormUIProps;

const ScreenFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  const displayTextInputs = (inputs: string[]) => {
    return inputs.map((input, index) => {
      return (
        <CustomFormControl key={index} isLoading={isLoading} label={meta[input as keyof IScreenFormMeta].label} isInvalid={!!errors[meta[input as keyof IScreenFormMeta].name]}>
          <CustomTextInput hasError={errors[meta[input as keyof IScreenFormMeta].name]} register={register(meta[input as keyof IScreenFormMeta].name)} meta={meta[input as keyof IScreenFormMeta]}/>
        </CustomFormControl>
      )
    })
  };

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      {/* Insert your form body here */}
        <CC.Stack
              direction={['column', 'column', 'row']}
              spacing={16}
          >
          {displayTextInputs([meta.bankID.name, meta.corporateName.name])}
        </CC.Stack>

        <CC.Stack
              direction={['column', 'column', 'row']}
              spacing={16} my={4}
          >
            {displayTextInputs([meta.id.name, meta.screenConfiguration.name])}
            
        </CC.Stack>

        <CC.Stack
              direction={['column', 'column', 'row']}
              spacing={16} my={4}
          >
            {displayTextInputs([meta.id2.name])}
            <CC.HStack gap={"1rem"} alignItems={"center"} w={"full"}>
              <CustomFormControl isLoading={isLoading} label={meta.name.label} isInvalid={!!errors[meta.name.name]}>
                  <CustomTextInput hasError={errors[meta.name.name]} register={register(meta.name.name)} meta={meta.name}/>
              </CustomFormControl>
              <CustomFormControl w={"2%"} isLoading={isLoading} isInvalid={!!errors[meta.nameCheckbox.name]}>
                  <CustomInputCheckBox mt={"2rem"} hasError={errors[meta.nameCheckbox.name]} register={register(meta.nameCheckbox.name)} meta={meta.nameCheckbox}></CustomInputCheckBox>
              </CustomFormControl>

            </CC.HStack>
            
        </CC.Stack>

        <CustomFormControl isLoading={isLoading} label={meta.text.label} isInvalid={!!errors[meta.text.name]}>
          <CustomTextArea hasError={errors[meta.text.name]} register={register(meta.text.name)} meta={meta.text}/>
        </CustomFormControl>

        <CC.HStack my={6} justifyContent={'flex-end'}>
          <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
        </CC.HStack>
    </CC.Box>
  );
};

export default ScreenFormUI;
